export default __webpack_public_path__ + "static/media/shutterstock_668022730_TUTORIALES_small.d6a6f731.webp";